export interface ILcRuntime {
    isTeams?: boolean;
    isSoge?: boolean;
    logo?: string;
}

declare const LC_RUNTIME: ILcRuntime | undefined;

const DEFAULT_CLIENT_LOGO = 'https://legalclustersigninpage.blob.core.windows.net/client-logos/legalcluster/legalcluster_logo.png';

const readWindowRuntime = (): ILcRuntime | undefined => {
    if (typeof window === 'undefined') {
        return undefined;
    }

    return window.__LC_RUNTIME__;
};

const readBundledRuntime = (): ILcRuntime | undefined => {
    return typeof LC_RUNTIME === 'undefined' ? undefined : LC_RUNTIME;
};

export const getLcRuntime = (): ILcRuntime => {
    return {
        ...readBundledRuntime(),
        ...readWindowRuntime()
    };
};

const isTeamsPath = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    const path = window.location.pathname || '';
    return path.startsWith('/teams') || path.startsWith('/teamsauth') || path === '/redirect-teams';
};

export const isTeamsInstance = (): boolean => {
    const runtime = getLcRuntime();
    if (runtime.isTeams === true) {
        return true;
    }

    return isTeamsPath();
};

export const isSogeInstance = (): boolean => getLcRuntime().isSoge === true;

export const getRuntimeClientLogo = (): string => getLcRuntime().logo || DEFAULT_CLIENT_LOGO;

export const DEFAULT_PLATFORM_LOGO = DEFAULT_CLIENT_LOGO;
